const logoSrc = require('../images/cc_logo_rgb.png');
import React from 'react';


export default class SiteNotAvailable extends React.Component {
    constructor() {
        super();
    }

    render() {
        return (
            <div>
                <div className="container" style={{ marginTop: '50px' }}>
                    <div className="row">
                        <div className="col-md-4 col-md-offset-4 text-center">
                            <img style={{ width:'100%' }} src={logoSrc} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-md-offset-4 text-center">
                            <h2 style={{ marginTop: '5px' }}>Customer Promise</h2>
                        </div>

                        <div className="col-md-4 col-md-offset-4 text-center">
                            <h3 style={{ marginTop: '120px' }}>We are sorry to say it’s not possible to login at the moment.</h3>
                            <h3 style={{ marginTop: '5px' }}>Our developers are working on finding a solution as soon as possible.</h3>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}